import { render, staticRenderFns } from "./CardStyle1All.vue?vue&type=template&id=5201040e&scoped=true&"
import script from "./CardStyle1All.vue?vue&type=script&lang=js&"
export * from "./CardStyle1All.vue?vue&type=script&lang=js&"
import style0 from "./CardStyle1All.vue?vue&type=style&index=0&id=5201040e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5201040e",
  null
  
)

export default component.exports